import React from "react";
import "../../assets/css/TermsUse.css";
import Headerr from "../Footer/QuickLinks/Headerr";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
const TermsUse = () => {
  return (
    <>
      <Headerr />
      <div className="privacy-header">
        <h1>Terms of Use</h1>
        <p>
          <Link to="/" className="breadcrumb-home">
            Home
          </Link>{" "}
          / <span className="breadcrumb-current">Terms of Use</span>
        </p>
      </div>

      <div className="terms-use-container">
        <div className="divider" />

        <h2>Introduction</h2>
        <p>
          Welcome to <strong>Rentel</strong>. These Terms of Use (“Terms”) govern your
          access to and use of the Rentel website, mobile application, and related
          services (collectively referred to as the “Platform”).
        </p>

        <p>
          Rentel is an online rentel marketplace that allows users to list and rent
          items such as <strong>clothes, cars, properties, cameras, machinery,
            furniture, clinic equipment, bikes</strong>, and other rentel items.
        </p>

        <p>
          By accessing or using Rentel, you confirm that you have read, understood,
          and agreed to be bound by these Terms. If you do not agree, please do not
          use the Platform.
        </p>

        <h2>Eligibility</h2>
        <p>
          Use of the Platform is available only to individuals who are capable of
          entering into legally binding contracts under the Indian Contract Act,
          1872. By using Rentel, you represent that you meet this requirement.
        </p>

        <h2>About Rentel</h2>
        <p>
          Rentel acts only as a technology platform to connect people who wish to
          rent out items (“Lenders”) with people who wish to take items on rent
          (“Borrowers”).
        </p>

        <p>
          Rentel does <strong>not</strong> own, inspect, manufacture, store, or rent
          any items listed on the Platform. All listings are created by independent
          users.
        </p>

        <h2>User Accounts</h2>
        <p>
          To access certain features of Rentel, you may be required to create an
          account. You are responsible for maintaining the confidentiality of your
          login credentials and for all activities carried out through your account.
        </p>

        <p>
          You agree to provide accurate, current, and complete information while
          creating or updating your account.
        </p>

        <p>
          Rentel reserves the right to suspend or terminate accounts if any
          information provided is found to be false, misleading, or in violation of
          these Terms.
        </p>

        <h2>Listing and Renting Items</h2>
        <p>
          Lenders are solely responsible for the accuracy, condition, pricing, and
          legality of items listed on Rentel.
        </p>

        <p>
          Borrowers are responsible for reviewing item details carefully before
          renting and for using the rented items responsibly and lawfully.
        </p>

        <h2>Payments and Transactions</h2>
        <p>
          Any payment, security deposit, rentel duration, or additional charges are
          agreed directly between the lender and the borrower.
        </p>

        <p>
          Rentel is not responsible for payment disputes, refunds, damages, delays,
          or losses arising from rentel transactions.
        </p>

        <h2>Prohibited Activities</h2>
        <p>
          Users agree not to misuse the Platform, including but not limited to:
        </p>
        <ul>
          <li>Posting false, misleading, or illegal listings</li>
          <li>Violating any applicable laws or regulations</li>
          <li>Attempting to harm the Platform or other users</li>
        </ul>

        <h2>Disclaimer</h2>
        <p>
          Rentel provides the Platform on an “as-is” and “as-available” basis. We do
          not guarantee the quality, safety, or legality of any listed items.
        </p>

        <p>
          Rentel does not participate in or control rentel agreements between users
          and shall not be responsible for any disputes, damages, or claims arising
          between lenders and borrowers.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Rentel shall not be liable for any
          direct, indirect, incidental, or consequential damages arising out of your
          use of the Platform.
        </p>

        <h2>Termination</h2>
        <p>
          Rentel reserves the right to suspend or terminate access to the Platform at
          any time, without prior notice, if these Terms are violated.
        </p>

        <h2>Changes to Terms</h2>
        <p>
          Rentel may update these Terms from time to time. Continued use of the
          Platform after changes are posted constitutes acceptance of the revised
          Terms.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions regarding these Terms, please contact us through
          the support section of the Rentel Platform.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default TermsUse;
